import React from "react";

interface FunctionButtonsProps {
  onCheckin: () => void;
  onCheckout: () => void;
  loading: boolean;
  disabled: boolean;
}

export default function FunctionButtons({
  onCheckin,
  onCheckout,
  loading,
  disabled,
}: FunctionButtonsProps) {
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: "12px",
      width: "100%",
      maxWidth: "90%"
    }}>
      <button
        onClick={onCheckin}
        disabled={loading || disabled}
        style={{
          padding: "14px",
          fontSize: "18px",
          fontWeight: "bold",
          borderRadius: "12px",
          border: "none",
          background: disabled || loading ? "#ddd" : "#1f883d",
          color: "#fff",
          cursor: disabled || loading ? "not-allowed" : "pointer",
          opacity: disabled || loading ? 0.6 : 1,
          boxShadow: "0 2px 8px rgba(31, 136, 61, 0.3)",
          transition: "all 0.2s"
        }}>
        {loading ? "처리 중..." : "등원"}
      </button>
      <button
        onClick={onCheckout}
        disabled={loading || disabled}
        style={{
          padding: "14px",
          fontSize: "18px",
          fontWeight: "bold",
          borderRadius: "12px",
          border: "none",
          background: disabled || loading ? "#ddd" : "#2466c2",
          color: "#fff",
          cursor: disabled || loading ? "not-allowed" : "pointer",
          opacity: disabled || loading ? 0.6 : 1,
          boxShadow: "0 2px 8px rgba(36, 102, 194, 0.3)",
          transition: "all 0.2s"
        }}>
        {loading ? "처리 중..." : "하원"}
      </button>
    </div>
  );
}
